const updateAddDocumentCompanies = {
  toastr: 'Documento actualizado',
  toastr1: 'El documento fue actualizado con éxito'
};

export default updateAddDocumentCompanies;
